import React from "react";
import { ListItem, ListItemAvatar, Avatar, ListItemText, Typography, IconButton, Box } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { ccyFormat } from "../../../helpers/helper";

const MovementData = ({ data, onRemove, colors }) => {
    return <Box key={data.id} display='flex' width='100%' sx={{ background: `${colors && colors.background}`, color: `${colors && colors.font}` }}>
      <ListItem
        sx={{paddingY: '0'}}
        alignItems="flex-start"
        secondaryAction={
          <Box display='flex' flexDirection='column' alignItems='flex-end'>
            <Typography alignSelf='flex-end' aria-label="delete" variant="h6">
              {`$${ccyFormat(data.price)}`}
            </Typography>
            <Typography
                component="span"
                variant="body2"
                color="text.primary"
                alignSelf='flex-end'
                sx={{ display: 'inline', background: `${colors && colors.background}`, color: `${colors && colors.font}` }}
            >
                {data.type}
            </Typography>
          </Box>
        }
      >
        <Box display='flex' flexDirection='row' width='100%'>
          <ListItemText
            primary={
              <Box display='flex' flexDirection='column' alignItems='flex-start' sx={{ width: '250px'}}>
                <Typography
                    display='flex'
                    component="span"
                    variant="body1"
                    color="text.primary"
                    sx={{ background: `${colors && colors.background}`, color: `${colors && colors.font}` }}
                    
                >
                    {data.user}
                </Typography>
                <Typography
                    display='flex'
                    component="span"
                    variant="caption"
                    color="text.secondary"
                    sx={{
                      background: `${colors && colors.background}`, color: `${colors && colors.font}`,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '100%' // Ajusta el ancho según sea necesario
                    }}
                >
                    {data.description}
                </Typography>
              </Box>
            }
            secondary={
              <React.Fragment>
                <Typography
                  display='flex'
                  component="span"
                  variant="body2"
                  color="text.primary"
                  sx={{ background: `${colors && colors.background}`, color: `${colors && colors.font}` }}
                >
                  {data.date}
                </Typography>
              </React.Fragment>
            }
          />
        </Box>
      </ListItem>
    </Box>
}

export default MovementData;